export default "__VITE_ASSET__s8hQ6sRD__"